var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ef2d29",
    fillRule: "evenodd",
    d: "M-.3-1.8h58.6v46H-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009025",
    fillRule: "evenodd",
    d: "M14.6 26.4h44.6v17.4H14.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.6-3h47v16h-47z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.7 5.8h-2l-.1.2v.9l.2.2h1.9l.2-.2v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.6 5.9H9.8l-.2.1v.8l.2.2h1.8q.2 0 .2-.2V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.6 6.2h.3v.1h.1v.3h-.6v-.1h-.1v-.1l.1-.1v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.7 6.5v-.2l-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m10 5.9-.3.2Zm0 0-.1.2Zm.2 0-.2.2Zm0 0-.1.2Zm.2 0-.2.2Zm.1 0-.2.2Zm.1 0-.2.2Zm.1 0-.1.2Zm.2 0-.2.2Zm0 0-.1.2Zm.2 0-.2.2Zm.1 0-.2.2Zm-.5 0-.1.2Zm.6 0-.1.2Zm.1 0-.1.2Zm.2 0-.2.2Zm0 0-.1.2Zm-.1 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Zm-.1 0 .1.2Zm-.2 0 .2.2Zm0 0v.2Zm-.2 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Zm-.2 0 .2.2Zm0 0 .1.2Zm-.2 0 .2.2Zm.5 0 .2.2Zm-.6 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Zm-.2 0 .2.2Zm.2.9-.2.2Zm.1 0V7Zm.2 0L10 7Zm0 0-.1.2Zm.2 0-.2.2Zm.1 0-.2.2Zm.1 0-.2.2Zm.1 0-.1.2Zm.2 0-.2.2Zm0 0-.1.2Zm.2 0-.2.2Zm.1 0L11 7Zm-.5 0-.1.2Zm.6 0-.1.2Zm.1 0-.1.2Zm.2 0-.2.2Zm0 0-.1.2Zm-.1 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Zm-.1 0 .1.2Zm-.2 0 .2.2Zm0 0V7Zm-.2 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Zm-.2 0 .2.2Zm0 0 .1.2Zm-.2 0 .2.2Zm.5 0 .2.2Zm-.6 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Zm-.2 0 .2.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 5.9-.3.2m.3-.2-.1.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.1.2zm.2 0-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.1.2m.2-.2-.1.2m.3-.2-.2.2m.3-.2-.2.2m0-.2.2.2m-.3-.2.2.2m-.3-.2.1.2m-.2-.2.1.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.1.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.1.2m-.3-.2.2.2m0 .7-.2.2m.3-.2V7m.3-.2L10 7m.3-.2L10 7m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.1.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2L11 7m.3-.2-.1.2m.2-.2-.1.2m.3-.2-.2.2m.3-.2-.2.2m0-.2.2.2m-.3-.2.2.2m-.3-.2.1.2m-.2-.2.1.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.1.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2m.3-.2.2.2m-.8-.2.2.2m-.3-.2.2.2m-.3-.2.1.2m-.3-.2.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 5.7H2V7h2l.2-.2V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 5.8H2v1l.2.2H4l.2-.2V6q0-.2-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m3 6.1.2.1h.1v.3H3v.1h-.4v-.1h-.1v-.2h.1v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3 6.5.1-.1-.1-.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2.2 5.9-.1.1Zm.2 0-.2.1Zm.2 0-.2.1Zm.1 0-.2.1Zm.1 0-.2.1Zm.3 0-.2.1Zm0 0L3 6Zm.2 0L3 6Zm.1 0-.2.1Zm.1 0-.2.1Zm-.4 0-.2.1Zm.7 0-.2.1Zm.2 0-.2.1Zm-.2 0L4 6Zm-.1 0 .2.1Zm-.1 0 .2.1Zm-.1 0 .1.1Zm-.2 0 .2.1Zm0 0 .1.1Zm-.2 0 .2.1Zm-.1 0 .2.1Zm-.1 0L3 6Zm-.1 0 .1.1Zm-.2 0 .2.1Zm.4 0 .2.1Zm-.6 0 .2.1Zm-.1 0 .2.1Zm-.1 0 .2.1Zm0 .8-.1.2Zm.2 0-.2.2Zm0 0-.1.2Zm.2 0-.2.2Zm.1 0-.2.2Zm.1 0-.2.2Zm.1 0-.1.2Zm.2 0-.2.2Zm0 0L3 7Zm.2 0L3 7Zm.1 0-.2.2Zm.1 0-.1.2Zm-.4 0-.2.2Zm.5 0-.1.2Zm.2 0-.2.2Zm0 0-.1.2Zm.2 0-.2.2Zm-.2 0L4 7Zm-.1 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Zm-.2 0 .2.2Zm0 0 .1.2Zm-.2 0 .2.2Zm-.1 0 .2.2Zm-.1 0L3 7Zm-.1 0 .1.2Zm-.2 0 .2.2Zm0 0 .1.2Zm.4 0 .2.2Zm-.6 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .2.2Zm-.1 0 .1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.2 5.9-.1.1m.3-.1-.2.1m.3-.1-.2.1m.3-.1-.2.1m.3-.1-.2.1m.3-.1-.2.1M3 6l-.1.1M3 6l-.2.1zm.3-.1L3 6m.3-.1-.2.1m.3-.1-.2.1m.3-.1-.1.1m.3-.1-.2.1m.3-.1-.2.1M4 6l-.2.1m0-.1H4m-.3 0 .2.1M3.6 6l.2.1M3.5 6l.1.1M3.3 6l.2.1M3.2 6l.2.1M3.1 6l.2.1M3 6l.2.1M2.9 6H3m-.2 0 .1.1M2.6 6l.2.1M2.5 6l.2.1M2.4 6l.2.1M2.3 6l.2.1M2.2 6l.2.1M2 6l.1.1m0 .7L2 7m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.1.2m.3-.2-.2.2m.3-.2L3 7m.3-.2L3 7m.3-.2-.2.2m.3-.2-.1.2m.2-.2-.1.2m.3-.2-.2.2m.3-.2-.2.2m.3-.2-.2.2m0-.2L4 7m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.1.2m-.3-.2.2.2m-.3-.2.2.2m-.3-.2.2.2M3 6.7l.2.2m-.3-.2L3 7m-.3-.2.1.2m-.3-.2.2.2m-.3-.2.2.2m.3-.2.2.2m-.8-.2.2.2m-.3-.2.2.2m-.3-.2.2.2M2 6.7l.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#ef2d28",
    strokeWidth: 0.1,
    d: "M5.5 8.4c-2.9 2.8-4 3.1-3.5 3.3.6.3 2.4-1.2 4.3-3 1.9-2 3-3.7 2.5-4-.6-.1-.3.7-3.3 3.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m3 10.4 1 .3c-.9.9-2 1.2-2.2 1-.3 0 .5-.5 1.3-1.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m3 10.5.9.2q-1.6 1.3-2 1c-.3 0 .4-.4 1.2-1.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 8.3v.2h-.3v.1m.1.1h-.4l-.1.1h-.2m.3.2h-.2l-.1.1H5v.3m0 .1h-.4v.3m.1.2-.1-.1v-.1.2l-.1.1H4m.1 0v.3h-.3v-.1.3m-.6.1h.2l.2.1-.2.1-.1.1v.1h-.1v-.2h-.4v.4h-.1l-.2-.1h-.1v.2l-.1.1h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.7 5.9c1.3-2.2 2.1-4 1.9-4.2-.2 0-1.4 1.6-2.7 3.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.6 5.8c1.3-2 2-3.9 2-4A14 14 0 0 0 8 5.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 5.8c1.3-2 2-3.9 2-4A14 14 0 0 0 8 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.4 4.7-.4.8.6.3.5-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.5 4.8-.4.7.5.2L9 5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.8 5.1-.3-.2-.3.6.4.1zm0 0-.6.4Zm-.2.5V5Zm1.8-3.1-.4-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.8 5.1-.3-.2m.3.2-.2.5m.2-.5-.6.4m.3-.6-.3.6m.3-.6v.7m-.3-.1.4.1m1.8-3.1-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef0000",
    stroke: "#ef2d28",
    strokeWidth: 0.1,
    d: "m10.4 2.3-.2-.1.1-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#ef2d28",
    strokeWidth: 0.1,
    d: "M8.2 8.3c2.9 2.8 4 3.2 3.5 3.4s-2.4-1.2-4.3-3.1S4.4 5 5 4.7s.3.7 3.3 3.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m10.6 10.4-1 .2q1.7 1.5 2.3 1.1c.3-.1-.5-.5-1.3-1.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m10.6 10.5-.8.2q1.6 1.1 2 1c.3-.1-.4-.4-1.2-1.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6 8.2.2.1H8m-.2.2h.4v.1h.1v.1h.2m-.3.2h.3V9h.1v.2m.1.1H9l.1.1v.3m-.1.1h.2v-.1.2h.4m0 0v.3q.1.2.2 0h.1v.2m.6.2H10v.1h.2l.1.2h.1v-.1h.2zh.2v.4h.1l.2-.1.1.1v.2h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 5.8c-1.3-2.2-2.1-4-2-4.1s1.4 1.5 2.7 3.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 5.8c-1.2-2.1-2-4-1.8-4a14 14 0 0 1 2.5 3.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5.8c-1.2-2.1-2-4-1.8-4a14 14 0 0 1 2.5 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.3 4.7.4.8-.6.3-.5-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.2 4.8.4.7-.5.2-.4-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m4.9 5 .3-.1.3.5-.4.2zm0 0 .6.4Zm.2.6v-.7ZM3.3 2.4l.4-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.9 5 .3-.1m-.3.1.2.6M5 5l.6.4M5.2 5l.3.5M5.2 5v.7m.3-.2-.4.2M3.3 2.4l.4-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef0000",
    stroke: "#ef2d28",
    strokeWidth: 0.1,
    d: "M3.3 2.2h.2L3.4 2l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m6 4.7-.1 2.6c-.2.1-3.7 0-3.7.5s3 1 3.8 1q1.8 0 1.7-1.5V4.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6 5.2v.3h1.7v-.3zm0-.5V5h1.7v-.3zM6 5v.2h1.7V5zm0 .5v.2h1.7v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 5.2V5zm.4 0V5zm.9 0V5zm.4 0V5h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m6 6 1.7 1.4Zm.2 0 1.5 1.3Zm.2 0 1.3 1.1Zm.2 0 1.1 1Zm.1 0 1 .8ZM7 6l.8.6Zm.2 0 .6.5Zm.2 0 .4.4Zm.2 0 .2.3Zm.1 0 .1.2ZM6 6.3l1.7 1.4ZM7.7 6 5.8 7.6Zm-.1 0L5.9 7.4Zm-.3 0L6 7.2Zm-.1 0L6 7ZM7 6l-1 .8Zm-.2 0-.8.6Zm-.2 0-.6.5Zm-.1 0-.5.4Zm-.2 0-.3.3ZM6 6l-.1.2Zm1.6.2L5.8 7.7Zm0 .1L5.8 8Zm0 .2L5.8 8Zm0 .1L5.8 8.2Zm0 .2L5.8 8.4Zm0 .2L5.8 8.5Zm0 .1L5.8 8.7Zm0 .2L5.8 8.8Zm0 .1L6 9Zm0 .2L6.1 8.9Zm0 .2-1.3 1Zm0 .2-1.1.8Zm-.2.3-.5.4ZM6 6.3l1.7 1.4Zm0 .2 1.7 1.3Zm0 .1L7.6 8Zm0 .2 1.6 1.3ZM6 7l1.6 1.2Zm0 0 1.5 1.3Zm0 .2 1.4 1.2Zm-.1.1 1.4 1.2Zm0 .1 1.3 1.1Zm0 .2 1.3 1Zm0 .1 1 1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6 1.7 1.4L6 9m.2-3 1.5 1.3M6.4 6l1.3 1M6.6 6l1.1.9m-1-1 1 .8M7 6.1l.8.5m-.6-.5.6.4-2 1.5m1.5-2 .4.3M7.5 6l.2.2m0-.2L5.8 7.8M6 6.2l1.7 1.4m0-1.6L5.8 7.6M7.6 6 5.9 7.4M7.3 6 6 7m1.2-1L6 7m1-1-1 .8m.8-.7-.8.5L7.6 8m-1-1.8-.6.4m.5-.4-.5.3m.3-.3-.3.2m1.7-.2L5.8 8m2-1.3-2 1.6m2-1.4-2 1.6m2-1.4-2 1.5m2-1.4-2 1.6m2-1.4-2 1.5m2-1.2L6 8.9m1.6-1.1-1.3 1M7.6 8l-1 .8m1-.5-.6.4M6 6.3l1.7 1.4M6 6.5l1.7 1.3M6 6.8l1.6 1.3M6 7l1.6 1.2M5.9 7.1l1.6 1.2M6 7.3l1.5 1M6 7.3l1.4 1.2m-1.5-1 1.4 1m-1.4-1 1.4 1.1m-1.4-.9 1.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6 5.8V6h1.7v-.2zm-.2 2.1 1 .8Zm0 .2 1 .7Zm0 .1.8.6Zm0 .2.6.4Zm0 .1.5.4Zm0 .2.3.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.8 7.9 1 .8m-1-.6 1 .7m-1-.6.8.6m-.8-.4.6.4m-.6-.3.5.4m-.5-.2.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m3.5 8.5 2-1.1Zm-.2 0 2-1.1Zm0-.2 1.8-1Zm0 0 1.5-1ZM3 8l1.5-.7Zm0-.1 1-.6Zm0-.2.8-.4Zm0-.1.5-.3Zm.5.8 2-1Zm.2 0 1.9-1Zm.2.1 1.8-1Zm.2 0L5.6 8Zm.2 0L5.7 8Zm.2.1 1-.5Zm.2 0 .8-.4Zm.2 0 .7-.3Zm.2.1.5-.2Zm.3 0 .3-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 8.5 2-1.1m-2.2 1 2-1m-2 1 1.8-1m-1.9.8 1.6-.8M3.1 8l1.5-.7M3.2 8l1-.6m-1 .4.7-.4m-.8.3.5-.3m0 1.1 2-1m-1.8 1 1.9-1M4 8.7l1.8-1m-1.6 1L5.6 8m-1.2.8L5.7 8m-1.1.7 1-.5m-.8.6.8-.5m-.6.5.7-.4m-.5.4.5-.2m-.2.2.3-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.9 7.3h-.3q-.1.7 0 1.6h.3q-.1-.7 0-1.6M2.4 8l.7-.5Zm0-.3.7.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.4 8 .7-.5m-.7.2.7.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.5 7.4H3v1l.4.1zm4.2-2.6v-.3q-.4 0-.4-.3h-.9q0 .3-.4.3v.3zM6.5 4h.7v.2h-.7zm0-.4h.7v.3h-.6zm0-.3h.7v.3h-.6zm.1-.4h.5v.4h-.5zm0-.4H7v.4h-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 3.6h-.6v.3h.6zm0 0v-.3h-.6v.3zm-.7.3h.7v.3h-.7zm.1-1h.5v.4h-.5zm0-.4H7v.4h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.9 2.7q.7-.1.7-.5T7 1.7q-.7 0-.7.5t.7.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m7.3 2.1.1.4-.5.2q-.4 0-.6-.2l.2-.4-.2-.3a1 1 0 0 1 1.1 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m7.1 2.1.2.5h-.8l.2-.5-.2-.3.4-.1h.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.2 2.3.1-.1-.1-.2-.2.2zm1.4 0 .2-.1q0-.2-.2-.2l-.2.2zm-.7 0 .2-.1-.2-.2-.2.2zm0-.5.2-.1-.2-.2q-.2 0-.2.2zm-.5 3 .2-.2-.2-.1-.2.1q0 .2.2.2m1 0 .2-.2-.2-.1-.2.1q0 .2.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.4 4.2h.9l-.4.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.9 4.8q.2 0 .2-.2L7 4.4q-.3 0-.3.2t.3.2m.2 1.4H5.9v.2h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.7 5.9q-.3 0-.3.3v.4H8V6zm0 .1-.2.2v.2l.2.2.1-.2v-.2zM6 6l-.1.2v.2l.1.2q.2 0 .2-.2v-.2q0-.3-.2-.2m0-.2v1h.2q.3 0 .3-.2V6H6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.7 6-.2.3q0 .3.2.3l.1-.3zm0 0h-.2l-.1.1v.5h.2q.4 0 .4-.2v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 6q-.4 0-.4.2v.2q0 .3.4.3.2 0 .3-.3v-.2q0-.3-.3-.3m0-.2h-.4l-.1.2v.7H5q.5 0 .5-.2V6l-.2-.1h-.1zm3.8.3q-.3 0-.3.2v.3q0 .2.3.2t.3-.2v-.3zm0-.2h-.2l-.2.1-.1.1v.7l.3.1h.2q.5 0 .5-.3V6h-.1L9 5.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.4 6.2h-.6v.2h.6zm-.9-.1h-.3v.4h.3zm-1.9 0h-.4v.4h.4zM4.7 6H4v.5h.7zm5 .1h-.6v.5h.6z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/om.99e59f89bd63c2945728b19671e796a5.svg";
export { ForwardRef as ReactComponent };